import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { FC, ReactElement } from 'react';

import { Container } from '@/components';

import AccessIcon from './assets/Access.svg';
import DiamondIcon from './assets/Diamond.svg';
import ChatIcon from './assets/Chat.svg';

import styles from './styles.module.scss';

const FeatureItem: FC<{
  icon: ReactElement;
  title: string;
  description: string;
}> = ({ icon, title, description }) => {
  return (
    <Box className={styles.feature}>
      <Box className={styles.featureIcon}>{icon}</Box>
      <Typography variant="h4" className={styles.featureTitle}>
        {title}
      </Typography>
      <Typography variant="body1" className={styles.featureDescription}>
        {description}
      </Typography>
    </Box>
  );
};

export const FeatureHighlights: FC = () => {
  const { t } = useTranslation('pricingV2', { keyPrefix: 'futureHighlights' });

  return (
    <Box component="section" className={styles.section}>
      <Container>
        <Box className={styles.wrapper}>
          <Typography variant="h2" className={styles.title}>
            {t('title')}
          </Typography>
          <Box className={styles.features}>
            <FeatureItem
              icon={<AccessIcon />}
              title={t('items.0.title')}
              description={t('items.0.description')}
            />
            <FeatureItem
              icon={<DiamondIcon />}
              title={t('items.1.title')}
              description={t('items.1.description')}
            />
            <FeatureItem
              icon={<ChatIcon />}
              title={t('items.2.title')}
              description={t('items.2.description')}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
